//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getInstagramShopsState = createSelector(
  (state: ICuralateStore) => state.instagram.shops,
  (shops) => shops,
);

export const getInstagramShopsProductSearchModalState = createSelector(
  getInstagramShopsState,
  (shops) => shops.productSearchModal,
);
